// The screens this app has, generated from .appfactory/product-plan.json.
//
// Imported by the navigation shell rather than replacing it: the shell owns
// router.js — bottom-tabs, stack and sidebar produce different routers, and it
// rewrites that file on every `spec apply`. Two owners for one file is a silent
// fight, so the product contributes ROUTES and the shell decides what to do
// with them.
//
// `primary` marks a screen that earns a place in the navigation itself.

import TitlePage from './pages/TitlePage.vue';
import ResultsPage from './pages/ResultsPage.vue';
import CalendarPage from './pages/CalendarPage.vue';
import MyStreetPage from './pages/MyStreetPage.vue';
import AustraliaPage from './pages/AustraliaPage.vue';
import HowToPlayPage from './pages/HowToPlayPage.vue';
import SettingsPage from './pages/SettingsPage.vue';
import PlayPage from './pages/PlayPage.vue';

export const PRODUCT_ROUTES = [
  {
    id: 'title',
    path: '/',
    label: 'Switch On Christmas',
    component: TitlePage,
    primary: true,
    destination: true,
  },
  {
    id: 'results',
    path: '/results',
    label: 'Round over',
    component: ResultsPage,
    primary: false,
    destination: true,
  },
  {
    id: 'calendar',
    path: '/calendar',
    label: 'Today\'s Street',
    component: CalendarPage,
    primary: false,
    destination: false,
  },
  {
    id: 'my-street',
    path: '/my-street',
    label: 'My Street',
    component: MyStreetPage,
    primary: false,
    destination: false,
  },
  {
    id: 'australia',
    path: '/australia',
    label: 'Australia lights up',
    component: AustraliaPage,
    primary: false,
    destination: false,
  },
  {
    id: 'how-to-play',
    path: '/how-to-play',
    label: 'How to play',
    component: HowToPlayPage,
    primary: false,
    destination: false,
  },
  {
    id: 'settings',
    path: '/settings',
    label: 'Settings',
    component: SettingsPage,
    primary: false,
    destination: false,
  },
  {
    id: 'play',
    path: '/play/:mode/:code?',
    label: 'Play',
    component: PlayPage,
    primary: false,
    destination: false,
  },
];

export const PRIMARY_ROUTES = PRODUCT_ROUTES.filter((r) => r.primary);

// What the navigation offers. NOT the same question as `primary`.
//
// The tab bar was built from PRIMARY_ROUTES, and `primary` means "the screen
// the app opens on" — exactly one screen per plan. So a four-screen app got a
// one-tab tab bar and three screens nothing could reach. `roles` grades
// importance for QA; it was never a claim about navigation.
//
// A destination is a top-level screen someone navigates TO: primary or
// critical, never a detail screen (reached from its list) and never settings
// (which gets its own toolbar button, because a settings tab crowds out a real
// one). Capped at five — past that a bottom bar stops being usable and the
// platform guidelines say so.
export const DESTINATION_ROUTES = PRODUCT_ROUTES.filter((r) => r.destination).slice(0, 5);
export const HOME_ROUTE = (PRIMARY_ROUTES[0] ?? PRODUCT_ROUTES[0])?.path ?? '/';
